import React, { FC, useEffect, useState } from 'react'
import { nowDate } from '../../../utils/date'

interface TaskDetail {
  task_id: number
  type: string
  origin_task_id: number | null
  time: number
  service_name: string | null
  icon: string | null
  icon_color: string | null
  task_name: string | null
  file_path: string | null
  included_url_parts: string | null
  exclusion_id: number | null
  timeline: {
    start_time: string
    end_time: string
  }[]
  label: {
    label_group_id: number
    label_group_name: string
    label_group_color: string
    label_id: number
    label_name: string
    label_color: string
    disabled: boolean
    status: string
  } | null
  is_loading?: boolean
}

interface Props {
  task: TaskDetail | undefined
  isDisplay: boolean
  updateCallback: (targetId: number, targetType: string) => void
  closeCallback: VoidFunction
}

const ExclusionAutoLabelingConfirmationModal: FC<Props> = (props) => {
  const {
    task,
    isDisplay,
    updateCallback,
    closeCallback,
  } = props

  const [scrollY, setScrollY] = useState<number>(0)

  useEffect(() => {
    const html = document.querySelector('html')
    if (!html) return
    if (isDisplay) {
      const scroll = window.scrollY
      html.classList.add('modal_open')
      html.style.top = `-${scroll}px`
      setScrollY(scroll)
    } else {
      html.classList.remove('modal_open')
      window.scrollTo(0, scrollY)
      setScrollY(0)
    }
  }, [isDisplay])

  return (
    <>
      {
        isDisplay && (
          <div className="modal_wrap">
            <div className={`confirmation_modal ${isDisplay || 'none'}`} style={{ width: "600px" }}>
              <div className="confirmation_modal_header">
                <div className="title">
                  自動仕分け対象外設定
                </div>
                <button type="button" className="close_modal" onClick={closeCallback}>
                  &times;
                </button>
              </div>
              <div className="confirmation_modal_body">
                {
                  task?.exclusion_id ? (
                    <>
                      <p>
                        {`「${task?.task_name}」の自動仕分け対象外設定を解除しますか？`}
                      </p>
                      <p>
                        {`(対象の作業データは現時刻(${nowDate("YYYY年MM月DD日 H:m")})より、自動仕分けの対象になります)`}
                      </p>
                    </>
                  ) : (
                    <>
                      <p>
                        {`「${task?.task_name}」を自動仕分け対象外に設定しますか？`}
                      </p>
                      <p>
                        {`(対象の作業データは現時刻(${nowDate("YYYY年MM月DD日 H:m")})より、自動仕分けされなくなります)`}
                      </p>
                    </>
                  )
                }
              </div>
              <div className="confirmation_modal_footer">
                <button type="button" className="button cancel" onClick={closeCallback}>
                  キャンセル
                </button>
                {
                  task?.exclusion_id ? (
                    <>
                      <button
                        type="button"
                        className="button delete"
                        onClick={() => {
                          updateCallback(task?.exclusion_id || 0, "delete")
                        }}
                      >
                        解除する
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        type="button"
                        className="button delete"
                        onClick={() => {
                          updateCallback(task?.task_id || 0, "create")
                        }}
                      >
                        設定する
                      </button>
                    </>
                  )
                }
              </div>
            </div>
            <div className="close_screen gray" role="presentation" onClick={closeCallback} />
          </div>
        )
      }
    </>
  )
}

export default ExclusionAutoLabelingConfirmationModal
